/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  CheckCircleFilled,
  LockOutlined,
  MailOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Button, Form, Input, message, Rate, Tag } from 'antd';
import LoginWithGoogle from 'components/loginWithGoogle';
import LoginWithSlack from 'components/loginWithSlack';
import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { register } from 'services/api/users';
import ProfileContext from 'services/profileContext';
import styles from 'styles/login.module.scss';
import { LOCAL_STORAGE } from 'utils/constants';
import { isAdmin, isConnected } from 'utils/utils';

const Argument = ({ content }) => (
  <div className={styles.argumentWrapper}>
    <div>
      <CheckCircleFilled className={styles.argumentIcon} />
    </div>
    <div className={styles.argumentContent}>{content}</div>
  </div>
);

const Register = () => {
  const [loading, setLoading] = useState(false);
  const [showRegisterEmail, setShowRegisterEmail] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const slackErrorParam = searchParams.get('slackError');
  const profileContext = useContext(ProfileContext);

  useEffect(() => {
    if (isConnected()) {
      navigate(
        profileContext && isAdmin(profileContext.profile)
          ? '/cycles'
          : '/my/cycles'
      );
    }
    // CANNOT_LINK_NEW_SLACK
    // NOT_AUTHORIZED
    if (slackErrorParam) {
      switch (slackErrorParam) {
        default:
        case 'NOT_AUTHORIZED':
          message.error('Insufficient permissions to link the Slack account');
          break;
      }
    }
  }, []);

  const onFinish = (values) => {
    setLoading(true);
    const refFromLocalStorage = localStorage.getItem(LOCAL_STORAGE.REF);
    const gacid = localStorage.getItem("gacid");
    const gclid = localStorage.getItem("gclid");
    const fbclid = localStorage.getItem("fbclid");
    const params = {
      email: values.email.trim(),
      password: values.password,
      ref: refFromLocalStorage,
      ...(gacid && { gacid: gacid }),
      ...(gclid && { gclid: gclid }),
      ...(fbclid && { fbclid: fbclid }),
    };
    register(params)
      .then(() => {
        // go to verify-email
        navigate(`/verify/${values.email}`);
      })
      .catch((e) => {
        console.error(e);
        message.error('Error during registration, please try again');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const refFromLocalStorage = localStorage.getItem(LOCAL_STORAGE.REF);
  const finalRef = refFromLocalStorage;

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <div className={styles.registerWrapper}>
          <div className={styles.registerLeft}>
            <div>
              <Tag color="blue">PERFORMANCE REVIEW</Tag>
            </div>
            <h1>Performance Reviews made easy for SMBs</h1>
            <div className={styles.rate} style={{ marginTop: 12 }}>
              <Rate defaultValue={5} disabled />
              <div className={styles.rateText}>4.9/5 (128)</div>
            </div>
            <div className={styles.argumentList}>
              <Argument content={'Performance review for SMBs'} />
              <Argument content={'First cycle for free'} />
              <Argument
                content={
                  'Run employee reviews 10x faster with 100x better learnings'
                }
              />
              <Argument content={'Simple to launch'} />
              <Argument content={'Get answers on time'} />
              <Argument
                content={
                  'AI guidance to get better employee feedback and help managers.'
                }
              />
            </div>
          </div>
          <div className={styles.vignetteWrapper}>
            <div className={styles.vignetteInner}>
              <div>
                <img
                  src="/img/logo.png"
                  width={130}
                  height={130}
                  alt="SimplePerf logo"
                  className={styles.logo}
                />
              </div>
              <h1>Register to SimplePerf</h1>
              <div>
                {showRegisterEmail ? (
                  <Form layout="vertical" onFinish={onFinish}>
                    <Form.Item
                      label="Enter your Business Email"
                      name="email"
                      placeholder="Enter your email"
                      rules={[
                        {
                          required: true,
                          message: 'Please input your email',
                        },
                      ]}
                    >
                      <Input
                        size={'large'}
                        prefix={<UserOutlined />}
                        type="email"
                        placeholder="Enter your email"
                      />
                    </Form.Item>

                    <Form.Item
                      label="Enter a Password"
                      name="password"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter a password',
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (!value) {
                              return Promise.resolve();
                            } else if (value.length < 8) {
                              return Promise.reject(
                                new Error(
                                  'The password must contain more than 8 caracters'
                                )
                              );
                            } else if (!/[A-Z]+/.test(value)) {
                              return Promise.reject(
                                new Error(
                                  'The password must contain at least 1 capital letter'
                                )
                              );
                            } else if (!/[a-z]/.test(value)) {
                              return Promise.reject(
                                new Error(
                                  'The password must contain at least 1 lowercase letter'
                                )
                              );
                            } else if (!/\d/.test(value)) {
                              return Promise.reject(
                                new Error(
                                  'The password must contain at least 1 number'
                                )
                              );
                            } else if (!/[^\w\s]/.test(value)) {
                              return Promise.reject(
                                new Error(
                                  'The password must contain at least 1 symbol'
                                )
                              );
                            } else {
                              return Promise.resolve();
                            }
                          },
                        }),
                      ]}
                    >
                      <Input.Password
                        size={'large'}
                        prefix={<LockOutlined />}
                        placeholder="Enter your password"
                      />
                    </Form.Item>
                    <Form.Item
                      label="Confirm the password"
                      name="confirm"
                      rules={[
                        {
                          required: true,
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (!value || getFieldValue('password') === value) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error(
                                'The new password that you entered do not match!'
                              )
                            );
                          },
                        }),
                      ]}
                    >
                      <Input.Password
                        size={'large'}
                        prefix={<LockOutlined />}
                        placeholder="Enter your password"
                      />
                    </Form.Item>
                    <Form.Item>
                      <Button
                        size={'large'}
                        type="primary"
                        block
                        loading={loading}
                        htmlType={'submit'}
                      >
                        Create my account
                      </Button>
                    </Form.Item>
                  </Form>
                ) : (
                  <div style={{ marginTop: 38, marginBottom: 14 }}>
                    <Button
                      style={{ marginBottom: 12 }}
                      size={'large'}
                      type="primary"
                      block
                      loading={loading}
                      onClick={() => {
                        setShowRegisterEmail(true);
                      }}
                      icon={<MailOutlined />}
                    >
                      Sign up with Email
                    </Button>
                    <LoginWithGoogle isLogin={false} refParam={finalRef} />
                    <LoginWithSlack isLogin={false} refParam={finalRef} />
                  </div>
                )}

                <div className={styles.actions}>
                  <a href="/#/login">
                    <Button type="link">Already have an account? Login.</Button>
                  </a>
                  {showRegisterEmail && (
                    <a
                      onClick={() => {
                        setShowRegisterEmail(false);
                      }}
                    >
                      <Button type="link">Show other Sign up options</Button>
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
